import {
    ADD_PAYMENT_ERROR,
    ADD_PAYMENT_START,
    ADD_PAYMENT_SUCCESS,
    REFERRAL_ID,
    SET_PAYMENT_METHOD_DELETE_ERROR,
    SET_PAYMENT_METHOD_DELETE_LOADING,
    SET_PAYMENT_METHOD_DELETE_SUCCESS,
    SET_PAYMENT_METHOD_ERROR,
    SET_PAYMENT_METHOD_ROLE_ERROR,
    SET_PAYMENT_METHOD_ROLE_LOADING,
    SET_PAYMENT_METHOD_ROLE_SUCCESS,
    UPDATE_CUSTOMER_ERROR,
    UPDATE_CUSTOMER_PENDING,
    UPDATE_CUSTOMER_SUCCESS,
} from './types';

const initialState = {
    isLoading: false,
    isCardLoading: false,
    paymentMethodDeleteLoadingCardId: '',
    paymentMethodRoleLoadingCardId: '',
    paymentMethodRoleLoadingType: '',
    userData: null,
    searchData: {},
    tempData: null,
    referralId: '',
};

const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'TEMP_DATA':
            return {
                ...state,
                tempData: action.payload,
            };
        case 'SET_USER':
            return {
                ...state,
                userData: action.payload,
            };
        case 'SET_SEARCH_DATA':
            return {
                ...state,
                searchData: action.payload,
            };
        case UPDATE_CUSTOMER_PENDING:
            return {
                ...state,
                isLoading: true,
            };
        case ADD_PAYMENT_START:
            return {
                ...state,
                isCardLoading: true,
            };
        case SET_PAYMENT_METHOD_ROLE_LOADING:
            return {
                ...state,
                isCardLoading: true,
                paymentMethodRoleLoadingCardId: action.payload?.cardId || '',
                paymentMethodRoleLoadingType: action.payload?.type || '',
            };
        case SET_PAYMENT_METHOD_DELETE_LOADING:
            return {
                ...state,
                isCardLoading: true,
                paymentMethodDeleteLoadingCardId: action.payload?.cardId || '',
            };
        case REFERRAL_ID:
            return {
                ...state,
                referralId: action.payload,
            };
        case UPDATE_CUSTOMER_SUCCESS:
        case UPDATE_CUSTOMER_ERROR:
        case ADD_PAYMENT_SUCCESS:
        case ADD_PAYMENT_ERROR:
        case SET_PAYMENT_METHOD_ERROR:
        case SET_PAYMENT_METHOD_ROLE_SUCCESS:
        case SET_PAYMENT_METHOD_ROLE_ERROR:
        case SET_PAYMENT_METHOD_DELETE_SUCCESS:
        case SET_PAYMENT_METHOD_DELETE_ERROR:
            return {
                ...state,
                isLoading: false,
                isCardLoading: false,
                paymentMethodDeleteLoadingCardId: '',
                paymentMethodRoleLoadingCardId: '',
                paymentMethodRoleLoadingType: '',
            };
        default:
            return state;
    }
};

export default userReducer;
